<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>person_add_alt_1</md-icon>
        </div>
        <h4 class="title">Extras</h4>
      </md-card-header>

      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="newExtra"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Extra</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>

        <template v-if="extras.length">
          <a
            href="#"
            @click.stop="viewExtra(extra)"
            v-for="extra in extras"
            :key="extra.title"
          >
            <div class="md-layout extra">
              <div class="md-layout-item md-size-70">
                <h6>
                  <a href="#" @click.prevent="viewExtra(extra)">{{
                    extra.title
                  }}</a>
                </h6>
              </div>
              <div class="md-layout-item md-size-30 text-right">
                <md-button
                  class="md-just-icon md-simple md-danger "
                  @click="deleteExtra(extra)"
                >
                  <md-icon>delete</md-icon>
                  <md-tooltip md-direction="top">Delete</md-tooltip>
                </md-button>
              </div>
            </div>
          </a>
        </template>

        <md-empty-state v-else md-label="Extra...">
          <md-button class="md-primary md-raised" @click="newExtra"
            >Create a new Extra</md-button
          >
        </md-empty-state>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["extras"],

  data() {
    return {};
  },

  methods: {
    newExtra() {
      this.$emit("addExtra");
    },

    viewExtra(extra) {
      this.$emit("viewExtra", extra);
    },

    deleteExtra(extra) {
      this.$emit("deleteExtra", extra);
    }
  }
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
.extra {
  border-bottom: 1px solid #00bcd4;
  margin-bottom: 1em;

  .md-layout-item {
    padding: 0;
  }
}
</style>
